/*
 * Copyright (c) 2023 Limpide
 *
 *  Permission is hereby granted, free of charge, to any person obtaining a copy of
 *  this software and associated documentation files (the "Software"), to deal in
 *  the Software without restriction, including without limitation the rights to
 *  use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of
 *  the Software, and to permit persons to whom the Software is furnished to do so,
 *  subject to the following conditions:
 *
 *  The above copyright notice and this permission notice shall be included in all
 *  copies or substantial portions of the Software.
 *
 *  THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 *  IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS
 *  FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR
 *  COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER
 *  IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN
 *  CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
 */

import Base from '@scripts/components/base'

export default class Popup extends Base {
    toggle?: HTMLButtonElement
    popup?: HTMLElement
    message?: HTMLDivElement
    toggleMessage?: HTMLButtonElement

    constructor(popup: HTMLElement) {
        super()

        const toggle = popup.querySelector('.btn-cta')
        const toggleMessage = popup.querySelector('.popup-message-close')
        const message = popup.querySelector('.popup-message')

        popup && (this.popup = popup)
        toggle && (this.toggle = toggle as HTMLButtonElement)
        toggleMessage && (this.toggleMessage = toggleMessage as HTMLButtonElement)
        message && (this.message = message as HTMLDivElement)
    }

    start() {
        const cookieId = this.toggleMessage?.dataset.id
        const expression = cookieId && new RegExp(cookieId)

        this.ready()

        expression &&
            !document.cookie.match(expression) &&
            this.message &&
            (this.message.style.display = 'flex') &&
            document.body.classList.add('popup-open')
        this.toggleMessage?.addEventListener('click', () => {
            cookieId && (document.cookie = `${this.toggleMessage?.dataset.id}=1;secure`)
            this.message?.remove()
            document.body.classList.remove('popup-open')
        })

        this.toggle?.addEventListener('click', () => {
            cookieId && (document.cookie = `${this.toggleMessage?.dataset.id}=1;secure`)
            this.message?.remove()
        })
    }
}
